document.addEventListener( "DOMContentLoaded", () => {
    toggleMobileMenu()
})

const toggleMobileMenu = () => {
    const HAMBURGUER = document.querySelector('#hamburguer-btn')
    const CLOSE_BTN  = document.querySelector( '#mobile-nav-container .close-btn')
    const MOBILE_CONT = document.querySelector( '#mobile-nav-container' )
    HAMBURGUER.addEventListener( 'click', () => {
        MOBILE_CONT.classList.toggle( 'open' )
    })

    CLOSE_BTN.addEventListener( 'click', () => {
        MOBILE_CONT.classList.toggle( 'open' )
    })
}